import IframeResizer from 'iframe-resizer-react';
import { config } from '../../config';

const FreeTrialButton = () => {
    const url = config.marketplaceFreeTrialButtonUri;
    return <IframeResizer src={url} height={0} />;
};

export default FreeTrialButton;
